import { render, staticRenderFns } from "./errorApp.vue?vue&type=template&id=2170f61f&"
import script from "./errorApp.vue?vue&type=script&lang=js&"
export * from "./errorApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/errorApp.vue
// module id = 487
// module chunks = 30